export default "__VITE_ASSET__Dtih02vP__"